export default "__VITE_ASSET__DN$qJpJp__"